import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./FREDialogCallout.scss');

/**
 * Show a callout to help the users find a specific option on the settings page
 * @param target - option id
 */
export default function showFREDialogCallout(target: () => HTMLElement | null) {
    let calloutContainer: HTMLDivElement | null;

    const createCalloutContainer = () => {
        calloutContainer = document.createElement('div');
        document.body.appendChild(calloutContainer);
    };

    const removeCalloutContainer = () => {
        if (calloutContainer && document.body.contains(calloutContainer)) {
            ReactDOM.unmountComponentAtNode(calloutContainer);
            document.body.removeChild(calloutContainer);
            calloutContainer = null;
        }
    };

    // Show a callout and anchor it to the option
    let attempts = 0;
    const intervalId = window.setInterval(() => {
        const option = target();

        if (option || ++attempts > 3) {
            // Clear the interval
            window.clearInterval(intervalId);
        }

        if (option) {
            // Display the callout
            createCalloutContainer();
            ReactDOM.render(
                <React.StrictMode>
                    <Callout
                        gapSpace={30}
                        className={styles.callout}
                        target={option}
                        directionalHint={DirectionalHint.leftCenter}
                        isBeakVisible={false}
                        onDismiss={removeCalloutContainer}>
                        <div className={styles.pulse} />
                    </Callout>
                </React.StrictMode>,
                calloutContainer
            );
        }
    }, 1000);
}
